import React from "react";
import "./SideDrawer.css"
import { Menu, Space } from "antd";
import { useNavigate } from "react-router-dom";
import {
  AccountBookFilled, DashboardOutlined,
  LockFilled, SettingFilled, TransactionOutlined 
} from "@ant-design/icons";
import { BsFillPersonCheckFill, BsPeopleFill, BsClipboard2DataFill, BsFillDiagram3Fill } from "react-icons/bs";
import { HiBuildingOffice2 } from "react-icons/hi2";
import { GiTakeMyMoney, GiMoneyStack } from "react-icons/gi";
import { MdFireTruck } from "react-icons/md";
import { TbReportSearch } from "react-icons/tb"
import { BsPersonVideo2 } from "react-icons/bs";

const SideMenu = () => {
  const navigate = useNavigate();
  
  return (
    <div className="sidebar-container">
      <div className="sidebar-header">
      <div className="logo-container">
          <h2 className="logo-text">Admin Panel</h2>
        </div>
      </div>
      <div className="menu-container">
        <Menu
          onClick={({ key }) => {
            if (key === 'logout') {
              console.log("Logout clicked");
            } else {
              navigate(key);
            }
          }}
          className="custom-menu" 
          // style={{
          //   width: "250px",
          //   height: "100vh",
          //   padding: "20px",
          //   backgroundColor: "white" 
          // }}
          mode="inline"
          defaultOpenKeys={["dashboard"]}
          items={[
            {
              label: <span className="menu-item-label">Dashboard</span>,
              key: "/Dashboard",
              icon: <DashboardOutlined className="menu-icon" />,
              className: "menu-item"
            },

            {
              label: <span className="menu-item-label">Employees</span>,
              icon: <BsFillPersonCheckFill className="menu-icon"/>,
              children: [
                {
                  label: <span className="submenu-item-label">Employee View</span>,
                  key: "/allEmployees",
                  icon: <BsPersonVideo2 className="submenu-icon" />,
                  className: "submenu-item"
                },
                {
                  label: "Employee Pay",
                  key: "/viewEmployeePay",
                  icon: <BsPersonVideo2 className="submenu-icon" />,
                  className: "submenu-item"
                },
                
              ],
              className: "menu-item"
            },
            
            {
              label: <span className="menu-item-label">Attendance</span>,
              key: "/attendance",
              icon: <AccountBookFilled className="menu-icon" />,
              className: "menu-item"
            },
            
            {
              label: <span className="menu-item-label">Pay</span>,
              icon: <GiTakeMyMoney className="menu-icon" />,
              children: [
                {
                  label: <span className="submenu-item-label">Advance</span>,
                  key: "/advance",
                  icon: <TransactionOutlined className="submenu-icon" />,
                  className: "submenu-item"
                },

                {
                  label: <span className="submenu-item-label">Payroll</span>,
                  key: "/payroll",
                  icon: <GiMoneyStack className="submenu-icon" />,
                  className: "submenu-item"
                }
              ],
              className: "menu-item"
            },
            
            {
              label: <span className="menu-item-label">Truck Trip Details</span>,
              key: "/truckTrip",
              icon: <MdFireTruck className="menu-icon" />,
              className: "menu-item"
            },
            
            {
              label: <span className="menu-item-label">Reports</span>,
              key: "/reports",
              icon: <TbReportSearch className="menu-icon" />,
              className: "menu-item"
            },
            
            {
              label: <span className="menu-item-label">Settings</span>,
              icon: <SettingFilled className="menu-icon" />,
              children: [
                {
                  label: <span className="submenu-item-label">Organization</span>,
                  key: "/organization",
                  icon: <HiBuildingOffice2 className="submenu-icon" />,
                  className: "submenu-item"
                },
                {
                  label: <span className="submenu-item-label">Team</span>,
                  key: "/team",
                  icon: <BsPeopleFill className="submenu-icon" />,
                  className: "submenu-item"
                },
                {
                  label: <span className="submenu-item-label">Project</span>,
                  key: "/project",
                  icon: <BsClipboard2DataFill className="submenu-icon" />,
                  className: "submenu-item"
                },
                {
                  label: <span className="submenu-item-label">Desigination</span>,
                  key: "/desigination",
                  icon: <BsFillDiagram3Fill className="submenu-icon" />,
                  className: "submenu-item"
                },
              ],
              className: "menu-item"
            },
            
            {
              label: <span className="menu-item-label">Logout</span>,
              key: "logout",
              danger: true,
              icon: <LockFilled className="menu-icon" />,
              className: "menu-item"
            },
          ]}
        />
      </div>
    </div>
  );
};

export default SideMenu;

